// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import $ from 'jquery';
// import Navbar from '../Navbar';
// import Footer from '../Footer';
// import { useNavigate } from 'react-router-dom';
// import './shop.css';
// import ComboSection from '../ComboSection';
// import Login from '../Login';
// import { v4 as uuidv4 } from 'uuid';
// import {
//   fetchProducts,
//   selectFilteredProducts,
//   selectAllProducts,
//   selectProductsStatus,
//   selectProductsError,
//   setFlavorFilter,
//   setPriceRange,
//   setDiscountFilter,
//   setPackSizeFilter,
//   clearAllFilters,
//   getProductImage,
//   getSellingPrice,
//   getOriginalPrice,
//   getPackSize,
// } from '../../redux/productsSlice';

// // Guest Cart Service Functions
// const GUEST_CART_KEY = 'guest_cart';

// const getGuestCart = () => {
//   try {
//     const cart = localStorage.getItem(GUEST_CART_KEY);
//     return cart ? JSON.parse(cart) : [];
//   } catch (error) {
//     console.error('Error getting guest cart:', error);
//     return [];
//   }
// };

// const saveGuestCart = (cartItems) => {
//   try {
//     localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cartItems));
//   } catch (error) {
//     console.error('Error saving guest cart:', error);
//   }
// };

// const addToGuestCart = (productId, variantId, quantity, productDetails) => {
//   const guestCart = getGuestCart();
//   const existingItemIndex = guestCart.findIndex(
//     item => item.product_id === productId && item.variant_id === variantId
//   );
  
//   // CRITICAL FIX: For existing items, preserve the original price
//   if (existingItemIndex !== -1) {
//     // Get the existing price from the cart item
//     const existingPrice = guestCart[existingItemIndex].unit_price;
//     guestCart[existingItemIndex].quantity += quantity;
//     // NEVER change the price - preserve the original
//     guestCart[existingItemIndex].unit_price = existingPrice;
//     guestCart[existingItemIndex].price = existingPrice;
//   } else {
//     // Only for new items, use the current selling price
//     const unitPrice = parseFloat(productDetails.selling_price);
//     const validPrice = isNaN(unitPrice) ? 0 : unitPrice;
    
//     guestCart.push({
//       product_id: productId,
//       variant_id: variantId,
//       quantity: quantity,
//       name: productDetails.name,
//       unit_price: validPrice,
//       price: validPrice,
//       image: productDetails.main_image,
//       added_at: new Date().toISOString(),
//       item_type: 'product'
//     });
//   }
  
//   saveGuestCart(guestCart);
//   return guestCart;
// };

// const mergeGuestCartWithUserCart = async (customerId, token) => {
//   const guestCart = getGuestCart();
  
//   if (!guestCart || guestCart.length === 0) {
//     return { success: true, message: 'No guest cart to merge' };
//   }
  
//   let mergedCount = 0;
  
//   try {
//     for (const item of guestCart) {
//       const response = await fetch('https://evercorenutrition.com/ev_admin/api/cart/', {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           customer_id: String(customerId),
//           product_id: item.product_id,
//           variant_id: item.variant_id,
//           quantity: item.quantity
//         })
//       });
      
//       if (response.ok) {
//         mergedCount++;
//       }
//     }
    
//     // Clear guest cart after successful merge
//     localStorage.removeItem(GUEST_CART_KEY);
    
//     return { success: true, message: `Merged ${mergedCount} items from guest cart` };
//   } catch (error) {
//     console.error('Error merging guest cart:', error);
//     return { success: false, message: 'Failed to merge guest cart' };
//   }
// };

// const Shop = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [wishlist, setWishlist] = useState([]);
//   const [wishlistLoading, setWishlistLoading] = useState({});
//   const [selectedVariants, setSelectedVariants] = useState({});
//   const [addingToCart, setAddingToCart] = useState({});

//   const [showWarning, setShowWarning] = useState(false);
//   const [warningMessage, setWarningMessage] = useState('');
//   const [warningProduct, setWarningProduct] = useState(null);
  
//   // Add login popup state
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
  
//   // Add debouncing state for add to cart
//   const [lastAddedProduct, setLastAddedProduct] = useState(null);
//   const addToCartTimeout = useRef(null);

//   // Get both filtered and all products from Redux
//   const filteredProducts = useSelector(selectFilteredProducts);
//   const allProducts = useSelector(selectAllProducts);
//   const status = useSelector(selectProductsStatus);
//   const error = useSelector(selectProductsError);

//   const [selectedFlavors, setSelectedFlavors] = useState([]);
//   const [selectedDiscounts, setSelectedDiscounts] = useState([]);
//   const [selectedPackSizes, setSelectedPackSizes] = useState([]);
//   const [priceRange, setLocalPriceRange] = useState({ min: 0, max: 10000 });

//   // Add these state variables for dynamic filter options
//   const [availableFlavours, setAvailableFlavours] = useState([]);
//   const [availablePackSizes, setAvailablePackSizes] = useState([]);
  
//   // Add loading flag to prevent duplicate API calls
//   const [isFetchingWishlist, setIsFetchingWishlist] = useState(false);

//   const isAuthenticated = () => !!localStorage.getItem('authToken');

//   const getCustomerId = () => {
//     try {
//       const userData = localStorage.getItem('userData');
//       if (userData) {
//         const parsed = JSON.parse(userData);
//         return parsed.id || parsed.customer_id || null;
//       }
//     } catch (e) {}
//     return null;
//   };

//   // Helper functions for variants
//   const getDefaultVariant = (product) => {
//     if (product.variants && product.variants.length > 0) {
//       return product.variants[0];
//     }
//     return null;
//   };

//   const getSelectedVariant = (productId) => {
//     const selectedVariantId = selectedVariants[productId];
//     if (selectedVariantId) {
//       const product = allProducts.find(p => p.id === productId);
//       const variant = product?.variants?.find(v => v.id === selectedVariantId);
//       if (variant) return variant;
//     }
    
//     const product = allProducts.find(p => p.id === productId);
//     return getDefaultVariant(product);
//   };

//   const getVariantIdForCart = (productId) => {
//     const variant = getSelectedVariant(productId);
//     return variant?.id || null;
//   };

//   // Show toast message
//   const showToast = (message, isSuccess = true) => {
//     setWarningMessage(message);
//     setShowWarning(true);
//     setTimeout(() => setShowWarning(false), 3000);
//   };

//   // Fetch wishlist - with duplicate prevention
//   const fetchWishlistFromAPI = async () => {
//     if (isFetchingWishlist) return;
    
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) return;

//       const customerId = getCustomerId();
//       if (!customerId) return;
      
//       setIsFetchingWishlist(true);

//       const response = await fetch(
//         `https://evercorenutrition.com/ev_admin/api/wishlist/?customer_id=${customerId}`,
//         {
//           method: 'GET',
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         const products = data?.wishlist?.products || [];
//         const wishlistIds = products.map(item => item.id);
//         setWishlist(wishlistIds);
//       } else if (response.status === 401) {
//         localStorage.removeItem('authToken');
//       }
//     } catch (error) {
//       console.error('Error fetching wishlist:', error);
//     } finally {
//       setIsFetchingWishlist(false);
//     }
//   };

//   // Handle login success - with guest cart merge
//   const handleLoginSuccess = useCallback(async (user) => {
//     setShowLoginPopup(false);
    
//     // Refresh wishlist after login
//     await fetchWishlistFromAPI();
    
//     // Merge guest cart with user cart
//     const token = localStorage.getItem('authToken');
//     const customerId = getCustomerId();
    
//     if (token && customerId) {
//       const mergeResult = await mergeGuestCartWithUserCart(customerId, token);
//       if (mergeResult.success && mergeResult.message !== 'No guest cart to merge') {
//         showToast(mergeResult.message, true);
//       }
//     }
    
//     window.dispatchEvent(new Event('cartUpdated'));
//     window.dispatchEvent(new Event('wishlistUpdated'));
//     showToast('Login successful!', true);
//   }, []);

//   // Add to wishlist
//   const addToWishlistAPI = async (productId, quantity = 1) => {
//     if (!isAuthenticated()) {
//       setShowLoginPopup(true);
//       return false;
//     }

//     setWishlistLoading(prev => ({ ...prev, [productId]: true }));

//     try {
//       const token = localStorage.getItem('authToken');
//       const customerId = getCustomerId();

//       if (!customerId) {
//         showToast('Could not identify customer. Please login again.', false);
//         return false;
//       }

//       const response = await fetch('https://evercorenutrition.com/ev_admin/api/wishlist/', {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           customer_id: String(customerId),
//           product_id: productId,
//           quantity: quantity,
//         }),
//       });

//       if (response.ok) {
//         setWishlist(prev => [...prev, productId]);
//         showToast('Item added to wishlist!', true);
//         window.dispatchEvent(new Event('wishlistUpdated'));
//         return true;
//       } else if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         showToast('Session expired. Please login again.', false);
//         setShowLoginPopup(true);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         showToast(errorData.message || errorData.error || 'Failed to add to wishlist.', false);
//       }
//       return false;
//     } catch (error) {
//       console.error('Error adding to wishlist:', error);
//       showToast('Network error. Please try again.', false);
//       return false;
//     } finally {
//       setWishlistLoading(prev => ({ ...prev, [productId]: false }));
//     }
//   };

//   // Remove from wishlist
//   const removeFromWishlistAPI = async (productId) => {
//     if (!isAuthenticated()) {
//       setShowLoginPopup(true);
//       return false;
//     }

//     setWishlistLoading(prev => ({ ...prev, [productId]: true }));

//     try {
//       const token = localStorage.getItem('authToken');
//       const customerId = getCustomerId();

//       if (!customerId) {
//         showToast('Could not identify customer. Please login again.', false);
//         return false;
//       }

//       const response = await fetch(
//         `https://evercorenutrition.com/ev_admin/api/wishlist/?customer_id=${customerId}&product_id=${productId}`,
//         {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.ok) {
//         setWishlist(prev => prev.filter(id => id !== productId));
//         showToast('Item removed from wishlist', true);
//         window.dispatchEvent(new Event('wishlistUpdated'));
//         return true;
//       } else if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         showToast('Session expired. Please login again.', false);
//         setShowLoginPopup(true);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         showToast(errorData.message || errorData.error || 'Failed to remove from wishlist.', false);
//       }
//       return false;
//     } catch (error) {
//       console.error('Error removing from wishlist:', error);
//       showToast('Network error. Please try again.', false);
//       return false;
//     } finally {
//       setWishlistLoading(prev => ({ ...prev, [productId]: false }));
//     }
//   };

//   const toggleWishlist = async (productId) => {
//     if (!isAuthenticated()) {
//       showToast('Please login to manage wishlist', false);
//       setTimeout(() => {
//         setShowLoginPopup(true);
//       }, 1000);
//       return;
//     }
    
//     if (wishlist.includes(productId)) {
//       await removeFromWishlistAPI(productId);
//     } else {
//       await addToWishlistAPI(productId, 1);
//     }
//   };

//   // Helper function to check if product is in stock based on qty
//   const isInStock = (product) => {
//     if (product.qty !== undefined && product.qty !== null) {
//       return product.qty > 0;
//     }
//     return product.stock !== "Stockout" && product.stock !== "Out of Stock" && product.stock !== "out_of_stock";
//   };

//   // FIXED Add to cart with price protection - NEVER change price on subsequent adds
//   const addToCart = async (product) => {


//      const eventId = uuidv4();
//   if (window.fbq) {
//     window.fbq('track', 'Purchase', {
//       value: 1000,
//       currency: 'INR'
//     }, {
//       eventID: eventId
//     });
//   }

//   // Optional: Server Event
//   try {
//     await fetch('https://evercorenutrition.com/ev_admin/api/fb-event/', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         event_id: eventId,
//         value: 1000
//       })
//     });
//   } catch (error) {
//     console.log('FB event error:', error);
//   }
//     // Prevent double click
//     if (addingToCart[product.id]) return;
    
//     // Prevent adding the same product within 1 second
//     if (lastAddedProduct === product.id) {
//       showToast('Please wait before adding again', false);
//       return;
//     }
    
//     if (!isInStock(product)) {
//       showToast('This product is currently out of stock', false);
//       return;
//     }

//     setLastAddedProduct(product.id);
//     if (addToCartTimeout.current) {
//       clearTimeout(addToCartTimeout.current);
//     }
//     addToCartTimeout.current = setTimeout(() => {
//       setLastAddedProduct(null);
//     }, 1000);

//     setAddingToCart(prev => ({ ...prev, [product.id]: true }));

//     const variantId = getVariantIdForCart(product.id);
//     const selectedVariant = getSelectedVariant(product.id);
    
//     // CRITICAL: Get the EXACT price from the variant
//     let exactPrice = 0;
//     if (selectedVariant && selectedVariant.selling_price) {
//       exactPrice = parseFloat(selectedVariant.selling_price);
//     } else if (product.selling_price) {
//       exactPrice = parseFloat(product.selling_price);
//     } else if (product.price) {
//       exactPrice = parseFloat(product.price);
//     }
    
//     // Validate price
//     const validPrice = (typeof exactPrice === 'number' && !isNaN(exactPrice) && exactPrice > 0) 
//       ? exactPrice 
//       : 0;
    
//     try {
//       // If not authenticated, save to guest cart
//       if (!isAuthenticated()) {
//         const guestCart = getGuestCart();
//         const existingItemIndex = guestCart.findIndex(
//           item => item.product_id === product.id && item.variant_id === variantId
//         );
        
//         if (existingItemIndex !== -1) {
//           // CRITICAL FIX: ONLY change quantity, NEVER change price
//           // Preserve the existing unit_price from the cart item
//           const existingPrice = guestCart[existingItemIndex].unit_price;
//           guestCart[existingItemIndex].quantity += 1;
//           // Keep the original price, don't update it
//           guestCart[existingItemIndex].unit_price = existingPrice;
//           guestCart[existingItemIndex].price = existingPrice;
//         } else {
//           // Add new item with correct price
//           guestCart.push({
//             product_id: product.id,
//             variant_id: variantId,
//             quantity: 1,
//             name: product.name,
//             unit_price: validPrice,
//             price: validPrice,
//             selling_price: validPrice,
//             image: product.main_image,
//             added_at: new Date().toISOString(),
//             item_type: 'product'
//           });
//         }
        
//         saveGuestCart(guestCart);
//         showToast('Item added to cart!', true);
//         window.dispatchEvent(new Event('cartUpdated'));
//         return;
//       }

//       // User is authenticated - FIRST check if item already exists in cart
//       const token = localStorage.getItem('authToken');
//       const customerId = getCustomerId();

//       if (!customerId) {
//         showToast('Could not identify customer. Please login again.', false);
//         return;
//       }

//       // Fetch current cart to check if item exists and get its price
//       const currentCartResponse = await fetch(
//         `https://evercorenutrition.com/ev_admin/api/cart/?customer_id=${customerId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` }
//         }
//       );

//       let existingItem = null;
//       if (currentCartResponse.ok) {
//         const cartData = await currentCartResponse.json();
//         if (cartData.cart && cartData.cart.items) {
//           existingItem = cartData.cart.items.find(
//             item => item.product_id === product.id && item.variant_id === variantId
//           );
//         }
//       }

//       // If item exists, use its existing price; otherwise use current price
//       let priceToSend = validPrice;
//       if (existingItem && existingItem.unit_price) {
//         priceToSend = parseFloat(existingItem.unit_price);
//         console.log(`Item exists with price ₹${priceToSend}, preserving it`);
//       }

//       const response = await fetch('https://evercorenutrition.com/ev_admin/api/cart/', {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           customer_id: customerId,
//           product_id: product.id,
//           variant_id: variantId,
//           quantity: 1,
//           // CRITICAL: Send the preserved price if item exists
//           unit_price: priceToSend
//         }),
//       });

//       if (response.ok) {
//         showToast('Item added to cart!', true);
//         window.dispatchEvent(new Event('cartUpdated'));
//         setTimeout(() => {
//           window.dispatchEvent(new Event('cartUpdated'));
//         }, 200);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         showToast(errorData.message || errorData.error || 'Failed to add to cart.', false);
//       }
//     } catch (err) {
//       console.error('Add to cart error:', err);
//       showToast('Network error. Please try again.', false);
//     } finally {
//       setTimeout(() => {
//         setAddingToCart(prev => ({ ...prev, [product.id]: false }));
//       }, 500);
//     }
//   };

//   const shareProduct = (product) => {
//     const url = window.location.origin + '/product/' + product.id;
//     if (navigator.share) {
//       navigator.share({ title: product.name, text: 'Check out this product!', url });
//     } else {
//       navigator.clipboard.writeText(url);
//       showToast('Product link copied!', true);
//     }
//   };

//   const handleFlavorChange = (flavor, checked) => {
//     if (checked) setSelectedFlavors([...selectedFlavors, flavor]);
//     else setSelectedFlavors(selectedFlavors.filter(f => f !== flavor));
//   };

//   const handleDiscountChange = (discount, checked) => {
//     if (checked) setSelectedDiscounts([...selectedDiscounts, discount]);
//     else setSelectedDiscounts(selectedDiscounts.filter(d => d !== discount));
//   };

//   const handlePackSizeChange = (size, checked) => {
//     if (checked) setSelectedPackSizes([...selectedPackSizes, size]);
//     else setSelectedPackSizes(selectedPackSizes.filter(s => s !== size));
//   };

//   const handleClearFilters = () => {
//     setSelectedFlavors([]);
//     setSelectedDiscounts([]);
//     setSelectedPackSizes([]);
//     setLocalPriceRange({ min: 0, max: 10000 });
//     dispatch(clearAllFilters());
//   };

//   const closeWarning = () => {
//     setShowWarning(false);
//     setWarningMessage('');
//     setWarningProduct(null);
//   };

//   // Function to render star rating
//   const renderStars = (rating) => {
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     let stars = '';
    
//     for (let i = 0; i < fullStars; i++) {
//       stars += '★';
//     }
    
//     if (hasHalfStar) {
//       stars += '½';
//     }
    
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//     for (let i = 0; i < emptyStars; i++) {
//       stars += '☆';
//     }
    
//     return stars;
//   };

//   // ===========================================
//   // ✅ SINGLE EFFECT FOR INITIAL DATA LOADING
//   // ===========================================
//   useEffect(() => {
//     if (status === 'idle') {
//       dispatch(fetchProducts());
//     }
    
//     if (isAuthenticated()) {
//       fetchWishlistFromAPI();
//     }
//   }, [status, dispatch]);

//   // ===========================================
//   // ✅ SINGLE EFFECT FOR ALL FILTERS
//   // ===========================================
//   useEffect(() => {
//     dispatch(setFlavorFilter(selectedFlavors));
//     dispatch(setDiscountFilter(selectedDiscounts));
//     dispatch(setPackSizeFilter(selectedPackSizes));
//     dispatch(setPriceRange(priceRange));
//   }, [selectedFlavors, selectedDiscounts, selectedPackSizes, priceRange, dispatch]);

//   // ===========================================
//   // ✅ SINGLE EFFECT FOR VARIANT SELECTION
//   // ===========================================
//   useEffect(() => {
//     if (allProducts && allProducts.length > 0) {
//       const defaultVariants = {};
//       allProducts.forEach(product => {
//         if (product.variants && product.variants.length > 0) {
//           defaultVariants[product.id] = product.variants[0].id;
//         }
//       });
//       setSelectedVariants(defaultVariants);
//     }
//   }, [allProducts]);

//   // ===========================================
//   // ✅ SINGLE EFFECT FOR FILTER OPTIONS
//   // ===========================================
//   useEffect(() => {
//     if (allProducts && allProducts.length > 0) {
//       const flavours = new Set();
//       const packSizes = new Set();
      
//       allProducts.forEach(product => {
//         if (product.variants && product.variants.length > 0) {
//           product.variants.forEach(variant => {
//             if (variant.flavour && variant.flavour !== 'Default') {
//               flavours.add(variant.flavour);
//             }
//             if (variant.weight_display) {
//               packSizes.add(variant.weight_display);
//             }
//           });
//         }
//       });
      
//       setAvailableFlavours([...flavours].sort());
//       setAvailablePackSizes([...packSizes].sort());
//     }
//   }, [allProducts]);

//   // ===========================================
//   // ✅ SINGLE EFFECT FOR UI INITIALIZATION
//   // ===========================================
//   useEffect(() => {
//     $('.addcart-button').click(function () {
//       $(this).next().addClass('open');
//       $('.add-to-cart-box .qty-input').val('1');
//     });
//     $('.qty-left-minus').on('click', function () {
//       var $qty = $(this).siblings('.qty-input');
//       var _val = $($qty).val();
//       if (_val === '1') {
//         var _removeCls = $(this).parents('.cart_qty');
//         $(_removeCls).removeClass('open');
//       }
//       var currentVal = parseInt($qty.val());
//       if (!isNaN(currentVal) && currentVal > 0) {
//         $qty.val(currentVal - 1);
//       }
//     });
//     $('.qty-right-plus').click(function () {
//       if ($(this).prev().val() < 9) {
//         $(this).prev().val(+$(this).prev().val() + 1);
//       }
//     });
    
//     return () => {
//       $('.addcart-button').off('click');
//       $('.qty-left-minus').off('click');
//       $('.qty-right-plus').off('click');
//     };
//   }, []);
  
//   // ===========================================
//   // ✅ CLEANUP TIMEOUT ON UNMOUNT
//   // ===========================================
//   useEffect(() => {
//     return () => {
//       if (addToCartTimeout.current) {
//         clearTimeout(addToCartTimeout.current);
//       }
//     };
//   }, []);

//   if (status === 'loading') {
//     return (
//       <>
//         <Navbar />
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   if (status === 'failed') {
//     return (
//       <>
//         <Navbar />
//         <div className="text-center py-5">
//           <div className="alert alert-danger" role="alert">
//             Error loading products: {error}
//           </div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   return (
//     <>
//       <Navbar />

//       {/* Toast Notification */}
//       {showWarning && (
//         <div style={{
//           position: 'fixed', top: '20px', right: '20px',
//           backgroundColor: warningMessage.includes('added') || warningMessage.includes('removed') || warningMessage.includes('copied') || warningMessage.includes('Saved') ? '#4CAF50' : 
//                          (warningMessage.includes('out of stock') ? '#ff9800' : '#ff4444'),
//           color: 'white', padding: '15px 25px', borderRadius: '8px',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 9999,
//           display: 'flex', alignItems: 'center', gap: '10px', animation: 'slideIn 0.3s ease'
//         }}>
//           <i className={`fa-${warningMessage.includes('added') || warningMessage.includes('removed') || warningMessage.includes('copied') || warningMessage.includes('Saved') ? 'regular fa-circle-check' : 'solid fa-circle-exclamation'}`}></i>
//           <span>{warningMessage}</span>
//           <button onClick={closeWarning} style={{ background: 'none', border: 'none', color: 'white', marginLeft: '10px', cursor: 'pointer', fontSize: '18px' }}>×</button>
//         </div>
//       )}

//       {/* Login Popup Modal */}
//       {showLoginPopup && (
//         <div className="login-popup-overlay" onClick={() => setShowLoginPopup(false)}>
//           <div className="login-popup-container" onClick={(e) => e.stopPropagation()}>
//             <button className="login-popup-close" onClick={() => setShowLoginPopup(false)}>
//               <i className="fa-solid fa-times"></i>
//             </button>
//             <Login setOpen={setShowLoginPopup} onLoginSuccess={handleLoginSuccess} />
//           </div>
//         </div>
//       )}

//       <section className="section-b-space shop-section">
//         <div className="container-fluid-lg">
//           <div className="row">
//             <div className="col-12">
//               <div className="show-button flex flex-wrap items-center gap-2 p-4 bg-white md:p-2">
//                 <button
//                   className="flex-1 min-w-[140px] px-4 py-2 bg-gray-200 text-sm font-medium text-gray-800 rounded-md hover:bg-gray-300 active:bg-gray-400 transition-all md:flex-none md:px-3 md:text-base sidebar-filter-menu btn"
//                   type="button"
//                   onClick={() => setFilterOpen(!filterOpen)}
//                 >
//                   <i className="fa-solid fa-filter mr-2"></i>
//                   Filter 
//                 </button>
//                 {(selectedFlavors.length > 0 || selectedDiscounts.length > 0 ||
//                   selectedPackSizes.length > 0 || priceRange.max < 10000) && (
//                  <button 
//                   onClick={handleClearFilters}
//                   style={{
//                     padding: '8px 16px',
//                     backgroundColor: '#ef4444',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '6px',
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '6px'
//                   }}
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                     <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//                   </svg>
//                   Clear Filters
//                 </button>
//                 )}
//               </div>

//               {/* Filter Section */}
//               <div className={`top-filter-category ${filterOpen ? 'show' : ''}`}>
//                 <div className="row g-sm-4 g-3">
//                   <div className="col-xl-3 col-md-6">
//                     <div className="category-title"><h3 style={{ color: '#000' }}>Flavor</h3></div>
//                     <ul className="category-list custom-padding custom-height">
//                       {availableFlavours.length > 0 ? (
//                         availableFlavours.map((flavor, i) => (
//                           <li key={flavor}>
//                             <div className="form-check ps-0 m-0 category-list-box">
//                               <input 
//                                 className="checkbox_animated" 
//                                 type="checkbox" 
//                                 id={`flavor${i}`}
//                                 onChange={(e) => handleFlavorChange(flavor, e.target.checked)}
//                                 checked={selectedFlavors.includes(flavor)} 
//                               />
//                               <label className="form-check-label" htmlFor={`flavor${i}`}>
//                                 <span className="name">{flavor}</span>
//                               </label>
//                             </div>
//                           </li>
//                         ))
//                       ) : (
//                         <li className="text-muted">No flavours available</li>
//                       )}
//                     </ul>
//                   </div>

//                   <div className="col-xl-3 col-md-6">
//                     <div className="category-title"><h3 style={{ color: '#000' }}>Price Range</h3></div>
//                     <div className="range-slider p-3">
//                       <input type="range" className="form-range" min="0" max="10000" step="100"
//                         value={priceRange.max}
//                         onChange={(e) => setLocalPriceRange({ ...priceRange, max: parseInt(e.target.value) })} />
//                       <div className="d-flex justify-content-between mt-2">
//                         <span>₹0</span><span>₹{priceRange.max}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-xl-3 col-md-6">
//                     <div className="category-title"><h3 style={{ color: '#000' }}>Discount</h3></div>
//                     <ul className="category-list">
//                       {[['upto5', 'Upto 5%'], ['5to10', '5% - 10%'], ['10to15', '10% - 15%'], ['15to25', '15% - 25%'], ['above25', 'Above 25%']].map(([val, label], i) => (
//                         <li key={val}>
//                           <div className="form-check ps-0 m-0 category-list-box">
//                             <input className="checkbox_animated" type="checkbox" id={`discount${i + 1}`}
//                               onChange={(e) => handleDiscountChange(val, e.target.checked)}
//                               checked={selectedDiscounts.includes(val)} />
//                             <label className="form-check-label" htmlFor={`discount${i + 1}`}>
//                               <span className="name">{label}</span>
//                             </label>
//                           </div>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   <div className="col-xl-3 col-md-6">
//                     <div className="category-title"><h3 style={{ color: '#000' }}>Pack Size</h3></div>
//                     <ul className="category-list custom-padding custom-height">
//                       {availablePackSizes.length > 0 ? (
//                         availablePackSizes.map((size, i) => (
//                           <li key={size}>
//                             <div className="form-check ps-0 m-0 category-list-box">
//                               <input 
//                                 className="checkbox_animated" 
//                                 type="checkbox" 
//                                 id={`pack${i}`}
//                                 onChange={(e) => handlePackSizeChange(size, e.target.checked)}
//                                 checked={selectedPackSizes.includes(size)} 
//                               />
//                               <label className="form-check-label" htmlFor={`pack${i}`}>
//                                 <span className="name">{size}</span>
//                               </label>
//                             </div>
//                           </li>
//                         ))
//                       ) : (
//                         <li className="text-muted">No pack sizes available</li>
//                       )}
//                     </ul>
//                   </div>
//                 </div>
//               </div>

//               {/* Products Grid */}
//               <div className="row" style={{ margin: 0 }}>
//                 <div className="col-12" style={{ padding: 0 }}>
//                   <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr', width: '100%', margin: 0, padding: 0 }}>

//                     {filteredProducts.length === 0 ? (
//                       <div style={{ textAlign: 'center', padding: '40px', gridColumn: '1/-1' }}>
//                         <h4>No products found matching your filters</h4>
//                       </div>
//                     ) : (
//                       filteredProducts.map((product) => {
//                         const isInWishlist = wishlist.includes(product.id);
//                         const isWishlistLoading = wishlistLoading[product.id];
//                         const inStock = isInStock(product);
//                         const averageRating = product.average_rating || 0;
//                         const selectedVariant = getSelectedVariant(product.id);
//                         const variantPrice = selectedVariant?.selling_price || product.selling_price;
//                         const variantOriginalPrice = product.price;
//                         const variantDiscount = product.discount;

//                         return (
//                           <div key={product.id} style={{ width: '100%', padding: 0, margin: 0, boxShadow: "1px 2px 15px #868585", borderRadius: "10px" }}>
//                             <div
//                               onClick={() => navigate(`/product/${product.id}`)}
//                               style={{
//                                 borderRadius: '12px', overflow: 'hidden',
//                                 boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//                                 transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//                                 backgroundColor: '#f0f0f0', display: 'flex',
//                                 flexDirection: 'column', height: '100%',
//                                 cursor: 'pointer', position: 'relative',
//                                 opacity: inStock ? 1 : 0.8
//                               }}
//                               onMouseEnter={(e) => {
//                                 if (window.innerWidth > 768 && inStock) {
//                                   e.currentTarget.style.transform = 'translateY(-5px)';
//                                   e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
//                                 }
//                               }}
//                               onMouseLeave={(e) => {
//                                 e.currentTarget.style.transform = 'translateY(0)';
//                                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//                               }}
//                             >
//                               {/* Stock Status Badge */}
//                               {!inStock && (
//                                 <div style={{
//                                   position: 'absolute',
//                                   top: '10px',
//                                   left: '10px',
//                                   backgroundColor: '#ff4444',
//                                   color: 'white',
//                                   padding: '4px 12px',
//                                   borderRadius: '20px',
//                                   fontSize: '12px',
//                                   fontWeight: '600',
//                                   zIndex: 3,
//                                   boxShadow: '0 2px 8px rgba(255,68,68,0.3)'
//                                 }}>
//                                   <i className="fa-solid fa-clock" style={{ marginRight: '5px' }}></i>
//                                   Out of Stock
//                                 </div>
//                               )}

//                               <div style={{ 
//                                 position: 'relative', 
//                                 width: '100%',
//                                 aspectRatio: '1/1',
//                                 overflow: 'hidden', 
//                                 backgroundColor: '#f0f0f0' 
//                               }}>
//                                 <img
//                                   src={getProductImage(product)}
//                                   alt={product.name}
//                                   style={{ 
//                                     width: '100%',
//                                     height: '100%',
//                                     objectFit: 'cover',
//                                     padding: '0',
//                                     transition: 'transform 0.3s ease',
//                                     filter: inStock ? 'none' : 'grayscale(50%)'
//                                   }}
//                                   onMouseEnter={(e) => { if (window.innerWidth > 768 && inStock) e.currentTarget.style.transform = 'scale(1.05)'; }}
//                                   onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
//                                 />
                                
//                                 {/* BESTSELLER / MOST POPULAR BADGE - Check variant directly */}
//                                 {(() => {
//                                   // Get the selected variant or default variant
//                                   const variantToCheck = selectedVariant || (product.variants && product.variants[0]);
//                                   // Check if the variant has is_bestseller or is_most_popular = true
//                                   const isBestseller = variantToCheck?.is_bestseller === true;
//                                   const isMostPopular = variantToCheck?.is_most_popular === true;
                                  
//                                   if (isBestseller || isMostPopular) {
//                                     return (
//                                       <div style={{
//                                         position: 'absolute',
//                                         top: '10px',
//                                         left: '10px',
//                                         backgroundColor: '#ff9800',
//                                         color: 'white',
//                                         padding: '4px 12px',
//                                         borderRadius: '20px',
//                                         fontSize: '11px',
//                                         fontWeight: '700',
//                                         zIndex: 3,
//                                         boxShadow: '0 2px 8px rgba(255,152,0,0.3)',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '4px',
//                                         letterSpacing: '0.5px'
//                                       }}>
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="gold" stroke="gold" strokeWidth="0">
//                                           <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
//                                         </svg>
//                                         {isMostPopular ? 'MOST POPULAR' : 'BESTSELLER'}
//                                       </div>
//                                     );
//                                   }
//                                   return null;
//                                 })()}
                                
//                                 {/* Stock Status Badge (only show when out of stock) */}
//                                 {!inStock && (
//                                   <div style={{
//                                     position: 'absolute',
//                                     top: '10px',
//                                     left: '10px',
//                                     backgroundColor: '#ff4444',
//                                     color: 'white',
//                                     padding: '4px 12px',
//                                     borderRadius: '20px',
//                                     fontSize: '12px',
//                                     fontWeight: '600',
//                                     zIndex: 3,
//                                     boxShadow: '0 2px 8px rgba(255,68,68,0.3)'
//                                   }}>
//                                     <i className="fa-solid fa-clock" style={{ marginRight: '5px' }}></i>
//                                     OUT OF STOCK
//                                   </div>
//                                 )}

//                                 {/* Wishlist Button */}
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     toggleWishlist(product.id);
//                                   }}
//                                   disabled={isWishlistLoading}
//                                   style={{
//                                     position: 'absolute', top: '10px', right: '50px',
//                                     width: '35px', height: '35px', borderRadius: '50%',
//                                     border: 'none', backgroundColor: 'white',
//                                     boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                                     cursor: isWishlistLoading ? 'wait' : 'pointer',
//                                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                     zIndex: 2, opacity: isWishlistLoading ? 0.7 : 1
//                                   }}
//                                 >
//                                   {isWishlistLoading ? (
//                                     <span className="spinner-border spinner-border-sm" role="status" style={{ width: '16px', height: '16px' }}></span>
//                                   ) : (
//                                     <i
//                                       className={isInWishlist ? 'fa-solid fa-heart' : 'fa-regular fa-heart'}
//                                       style={{ color: isInWishlist ? '#ff4444' : '#333', fontSize: '16px' }}
//                                     ></i>
//                                   )}
//                                 </button>

//                                 {/* Share Button */}
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     shareProduct(product);
//                                   }}
//                                   style={{
//                                     position: 'absolute', top: '10px', right: '10px',
//                                     width: '35px', height: '35px', borderRadius: '50%',
//                                     border: 'none', backgroundColor: 'white',
//                                     boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                                     cursor: 'pointer', display: 'flex',
//                                     alignItems: 'center', justifyContent: 'center', zIndex: 2
//                                   }}
//                                 >
//                                   <i className="fa fa-share-alt" style={{ color: '#333' }}></i>
//                                 </button>
//                               </div>

//                               {/* Content Section */}
//                               <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
//                                 <h3 style={{ fontSize: '1.1rem', fontWeight: '600', margin: '0 0 8px 0', color: '#333', lineHeight: '1.4' }}>
//                                   <span style={{ color: '#333', textDecoration: 'none' }}>
//                                     {product.name}
//                                   </span>
//                                 </h3>

//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
//                                   <div style={{ color: '#ffc107', fontSize: '1rem', letterSpacing: '2px', marginRight: '5px' }}>
//                                     {renderStars(averageRating)}
//                                   </div>
//                                   <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '5px' }}>
//                                     ({averageRating > 0 ? averageRating.toFixed(1) : '0.0'})
//                                   </span>
//                                   <span style={{ fontSize: '0.85rem', color: '#999', marginLeft: '5px' }}>
//                                     ({product.total_reviews || 0} {product.total_reviews === 1 ? 'review' : 'reviews'})
//                                   </span>
//                                 </div>

//                                 <p style={{ fontSize: '0.9rem', color: '#666', margin: '0 0 10px 0' }}>
//                                   {getPackSize(product)}
//                                 </p>

//                                 <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px' }}>
//                                   <span style={{ fontSize: '1.3rem', fontWeight: '700', color: '#333' }}>
//                                     ₹{parseFloat(variantPrice || 0).toLocaleString('en-IN')}
//                                   </span>
//                                    {variantOriginalPrice > variantPrice && (
//                                     <span style={{ fontSize: '0.9rem', color: '#999', textDecoration: 'line-through', marginLeft: '8px' }}>
//                                       ₹{parseFloat(variantOriginalPrice || 0).toLocaleString('en-IN')}
//                                     </span>
//                                   )}
//                                   {variantDiscount > 0 && (
//                                     <>
//                                       <span style={{
//                                         display: 'inline-flex',
//                                         alignItems: 'center',
//                                         gap: '3px',
//                                         fontSize: '0.75rem',
//                                         color: '#fff',
//                                         backgroundColor: '#e53935',
//                                         padding: '4px 10px',
//                                         borderRadius: '20px',
//                                         marginLeft: '4px',
//                                         fontWeight: '700',
//                                         whiteSpace: 'nowrap'
//                                       }}>
//                                         {Math.floor(variantDiscount)}% OFF
//                                       </span>
//                                       {variantOriginalPrice > variantPrice && (
//                                         <span style={{
//                                           display: 'inline-flex',
//                                           alignItems: 'center',
//                                           gap: '4px',
//                                           fontSize: '0.75rem',
//                                           color: '#2e7d32',
//                                           backgroundColor: '#e8f5e9',
//                                           padding: '4px 10px',
//                                           borderRadius: '20px',
//                                           marginLeft: '4px',
//                                           fontWeight: '700',
//                                           border: '1px solid #a5d6a7',
//                                           whiteSpace: 'nowrap'
//                                         }}>
//                                           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                                             <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
//                                             <line x1="7" y1="7" x2="7.01" y2="7"/>
//                                           </svg>
//                                           Save ₹{Math.floor(parseFloat(variantOriginalPrice) - parseFloat(variantPrice)).toLocaleString('en-IN')}
//                                         </span>
//                                       )}
//                                     </>
//                                   )}
//                                 </div>

//                                 {/* Add to Cart Button */}
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     addToCart(product);
//                                   }}
//                                   disabled={!inStock || addingToCart[product.id] || lastAddedProduct === product.id}
//                                   style={{ 
//                                     width: '100%',
//                                     padding: '10px 12px', 
//                                     backgroundColor: !inStock ? '#999' : (addingToCart[product.id] || lastAddedProduct === product.id ? '#666' : '#000'), 
//                                     color: 'white', 
//                                     border: 'none', 
//                                     borderRadius: '6px', 
//                                     fontSize: '0.9rem', 
//                                     fontWeight: '600', 
//                                     cursor: (!inStock || addingToCart[product.id] || lastAddedProduct === product.id) ? 'not-allowed' : 'pointer', 
//                                     transition: 'background-color 0.2s ease',
//                                     opacity: (!inStock || addingToCart[product.id] || lastAddedProduct === product.id) ? 0.7 : 1,
//                                     marginTop: 'auto'
//                                   }}
//                                   onMouseEnter={(e) => { 
//                                     if (window.innerWidth > 768 && inStock && !addingToCart[product.id] && lastAddedProduct !== product.id) {
//                                       e.currentTarget.style.backgroundColor = '#333'; 
//                                     }
//                                   }}
//                                   onMouseLeave={(e) => { 
//                                     if (inStock && !addingToCart[product.id] && lastAddedProduct !== product.id) {
//                                       e.currentTarget.style.backgroundColor = '#000'; 
//                                     }
//                                   }}
//                                 >
//                                   {addingToCart[product.id] ? (
//                                     <span className="spinner-border spinner-border-sm" role="status" style={{ width: '14px', height: '14px', marginRight: '5px' }}></span>
//                                   ) : null}
//                                   {!inStock ? 'Out of Stock' : (addingToCart[product.id] ? 'Adding...' : (lastAddedProduct === product.id ? 'Added!' : 'Add to Cart'))}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <style>{`
//         @media (min-width: 768px) {
//           div[style*="display: grid"][style*="gap: 20px"] {
//             grid-template-columns: repeat(2, 1fr) !important;
//           }
//         }
//         @media (min-width: 1200px) {
//           div[style*="display: grid"][style*="gap: 20px"] {
//             grid-template-columns: repeat(4, 1fr) !important;
//           }
//         }
//         .container-fluid-lg {
//           padding-left: 15px !important;
//           padding-right: 15px !important;
//         }
//         @media (min-width: 768px) {
//           .container-fluid-lg { padding-left: 20px !important; padding-right: 20px !important; }
//         }
//         @media (min-width: 1200px) {
//           .container-fluid-lg { padding-left: 30px !important; padding-right: 30px !important; }
//         }
//         .row { margin-left: 0 !important; margin-right: 0 !important; }
//         .col-12 { padding-left: 0 !important; padding-right: 0 !important; }
//         @keyframes slideIn {
//           from { transform: translateX(100%); opacity: 0; }
//           to { transform: translateX(0); opacity: 1; }
//         }

//         /* Login Popup Styles */
//         .login-popup-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(255, 255, 255, 0.7);
//           backdrop-filter: blur(5px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 10000;
//           animation: fadeIn 0.3s ease;
//         }

//         .login-popup-container {
//           position: relative;
//           max-width: 500px;
//           width: 90%;
//           max-height: 90vh;
//           overflow-y: auto;
//           background: transparent;
//           border-radius: 20px;
//           animation: slideUp 0.3s ease;
//         }

//         .login-popup-close {
//           position: absolute;
//           top: 15px;
//           right: 15px;
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           background: white;
//           border: none;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 10;
//           font-size: 16px;
//           color: #333;
//           transition: all 0.2s ease;
//           box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//         }

//         .login-popup-close:hover {
//           background: #f0f0f0;
//           transform: scale(1.1);
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slideUp {
//           from {
//             transform: translateY(30px);
//             opacity: 0;
//           }
//           to {
//             transform: translateY(0);
//             opacity: 1;
//           }
//         }
//       `}</style>

//       <ComboSection title="Combo Offers" />
//       <Footer />
//     </>
//   );
// };

// export default Shop;



// Vishal Updated code

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import $ from 'jquery';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useNavigate } from 'react-router-dom';
import './shop.css';
import ComboSection from '../ComboSection';
import Login from '../Login';
import { v4 as uuidv4 } from 'uuid';
import {
  fetchProducts,
  selectFilteredProducts,
  selectAllProducts,
  selectProductsStatus,
  selectProductsError,
  setFlavorFilter,
  setPriceRange,
  setDiscountFilter,
  setPackSizeFilter,
  clearAllFilters,
  getProductImage,
  getSellingPrice,
  getOriginalPrice,
  getPackSize,
} from '../../redux/productsSlice';

// Guest Cart Service Functions
const GUEST_CART_KEY = 'guest_cart';

const getGuestCart = () => {
  try {
    const cart = localStorage.getItem(GUEST_CART_KEY);
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error getting guest cart:', error);
    return [];
  }
};

const saveGuestCart = (cartItems) => {
  try {
    localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cartItems));
  } catch (error) {
    console.error('Error saving guest cart:', error);
  }
};

const addToGuestCart = (productId, variantId, quantity, productDetails) => {
  const guestCart = getGuestCart();
  const existingItemIndex = guestCart.findIndex(
    item => item.product_id === productId && item.variant_id === variantId
  );
  
  // CRITICAL FIX: For existing items, preserve the original price
  if (existingItemIndex !== -1) {
    // Get the existing price from the cart item
    const existingPrice = guestCart[existingItemIndex].unit_price;
    guestCart[existingItemIndex].quantity += quantity;
    // NEVER change the price - preserve the original
    guestCart[existingItemIndex].unit_price = existingPrice;
    guestCart[existingItemIndex].price = existingPrice;
  } else {
    // Only for new items, use the current selling price
    const unitPrice = parseFloat(productDetails.selling_price);
    const validPrice = isNaN(unitPrice) ? 0 : unitPrice;
    
    guestCart.push({
      product_id: productId,
      variant_id: variantId,
      quantity: quantity,
      name: productDetails.name,
      unit_price: validPrice,
      price: validPrice,
      image: productDetails.main_image,
      added_at: new Date().toISOString(),
      item_type: 'product'
    });
  }
  
  saveGuestCart(guestCart);
  return guestCart;
};

const mergeGuestCartWithUserCart = async (customerId, token) => {
  const guestCart = getGuestCart();
  
  if (!guestCart || guestCart.length === 0) {
    return { success: true, message: 'No guest cart to merge' };
  }
  
  let mergedCount = 0;
  
  try {
    for (const item of guestCart) {
      const response = await fetch('https://evercorenutrition.com/ev_admin/api/cart/', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer_id: String(customerId),
          product_id: item.product_id,
          variant_id: item.variant_id,
          quantity: item.quantity
        })
      });
      
      if (response.ok) {
        mergedCount++;
      }
    }
    
    // Clear guest cart after successful merge
    localStorage.removeItem(GUEST_CART_KEY);
    
    return { success: true, message: `Merged ${mergedCount} items from guest cart` };
  } catch (error) {
    console.error('Error merging guest cart:', error);
    return { success: false, message: 'Failed to merge guest cart' };
  }
};

const Shop = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filterOpen, setFilterOpen] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistLoading, setWishlistLoading] = useState({});
  const [selectedVariants, setSelectedVariants] = useState({});
  const [addingToCart, setAddingToCart] = useState({});

  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [warningProduct, setWarningProduct] = useState(null);
  
  // Add login popup state
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  
  // Add debouncing state for add to cart
  const [lastAddedProduct, setLastAddedProduct] = useState(null);
  const addToCartTimeout = useRef(null);

  // Get both filtered and all products from Redux
  const filteredProducts = useSelector(selectFilteredProducts);
  const allProducts = useSelector(selectAllProducts);
  const status = useSelector(selectProductsStatus);
  const error = useSelector(selectProductsError);

  const [selectedFlavors, setSelectedFlavors] = useState([]);
  const [selectedDiscounts, setSelectedDiscounts] = useState([]);
  const [selectedPackSizes, setSelectedPackSizes] = useState([]);
  const [priceRange, setLocalPriceRange] = useState({ min: 0, max: 10000 });

  // Add these state variables for dynamic filter options
  const [availableFlavours, setAvailableFlavours] = useState([]);
  const [availablePackSizes, setAvailablePackSizes] = useState([]);
  
  // Add loading flag to prevent duplicate API calls
  const [isFetchingWishlist, setIsFetchingWishlist] = useState(false);

  const isAuthenticated = () => !!localStorage.getItem('authToken');

  const getCustomerId = () => {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsed = JSON.parse(userData);
        return parsed.id || parsed.customer_id || null;
      }
    } catch (e) {}
    return null;
  };

  // Helper functions for variants
  const getDefaultVariant = (product) => {
    if (!product?.variants?.length) return null;

    // 1. Agar backend me future me is_default aaye to usko priority do
    const explicitDefault = product.variants.find(
      v => v.is_default === true
    );
    if (explicitDefault) return explicitDefault;

    // 2. Product-level selling price + MRP + weight se matching variant dhoondo
    const matchedVariant = product.variants.find((v) => {
      const sameWeight =
        String(v.weight_value) === String(product.weight_value) &&
        String(v.weight_unit).toLowerCase() === String(product.weight_unit).toLowerCase();

      const samePrice =
        parseFloat(v.price || 0) === parseFloat(product.selling_price || 0);

      const sameMrp =
        parseFloat(v.mrp || 0) === parseFloat(product.price || 0);

      return sameWeight && samePrice && sameMrp;
    });

    if (matchedVariant) return matchedVariant;

    // 3. Weight + selling price match fallback
    const partialMatchedVariant = product.variants.find((v) => {
      const sameWeight =
        String(v.weight_value) === String(product.weight_value) &&
        String(v.weight_unit).toLowerCase() === String(product.weight_unit).toLowerCase();

      const samePrice =
        parseFloat(v.price || 0) === parseFloat(product.selling_price || 0);

      return sameWeight && samePrice;
    });

    if (partialMatchedVariant) return partialMatchedVariant;

    // 4. Last fallback
    return product.variants[0];
  };

  const getSelectedVariant = (productId) => {
    const selectedVariantId = selectedVariants[productId];
    if (selectedVariantId) {
      const product = allProducts.find(p => p.id === productId);
      const variant = product?.variants?.find(v => v.id === selectedVariantId);
      if (variant) return variant;
    }
    
    const product = allProducts.find(p => p.id === productId);
    return getDefaultVariant(product);
  };

  const getVariantIdForCart = (productId) => {
    const variant = getSelectedVariant(productId);
    return variant?.id || null;
  };
  const selectVariantForProduct = (productId, variantId) => {
    setSelectedVariants(prev => ({
      ...prev,
      [productId]: variantId
    }));
  };
  // Show toast message
  const showToast = (message, isSuccess = true) => {
    setWarningMessage(message);
    setShowWarning(true);
    setTimeout(() => setShowWarning(false), 3000);
  };

  // Fetch wishlist - with duplicate prevention
  const fetchWishlistFromAPI = async () => {
    if (isFetchingWishlist) return;
    
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const customerId = getCustomerId();
      if (!customerId) return;
      
      setIsFetchingWishlist(true);

      const response = await fetch(
        `https://evercorenutrition.com/ev_admin/api/wishlist/?customer_id=${customerId}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const products = data?.wishlist?.products || [];
        const wishlistIds = products.map(item => item.id);
        setWishlist(wishlistIds);
      } else if (response.status === 401) {
        localStorage.removeItem('authToken');
      }
    } catch (error) {
      console.error('Error fetching wishlist:', error);
    } finally {
      setIsFetchingWishlist(false);
    }
  };

  // Handle login success - with guest cart merge
  const handleLoginSuccess = useCallback(async (user) => {
    setShowLoginPopup(false);
    
    // Refresh wishlist after login
    await fetchWishlistFromAPI();
    
    // Merge guest cart with user cart
    const token = localStorage.getItem('authToken');
    const customerId = getCustomerId();
    
    if (token && customerId) {
      const mergeResult = await mergeGuestCartWithUserCart(customerId, token);
      if (mergeResult.success && mergeResult.message !== 'No guest cart to merge') {
        showToast(mergeResult.message, true);
      }
    }
    
    window.dispatchEvent(new Event('cartUpdated'));
    window.dispatchEvent(new Event('wishlistUpdated'));
    showToast('Login successful!', true);
  }, []);

  // Add to wishlist
  const addToWishlistAPI = async (productId, quantity = 1) => {
    if (!isAuthenticated()) {
      setShowLoginPopup(true);
      return false;
    }

    setWishlistLoading(prev => ({ ...prev, [productId]: true }));

    try {
      const token = localStorage.getItem('authToken');
      const customerId = getCustomerId();

      if (!customerId) {
        showToast('Could not identify customer. Please login again.', false);
        return false;
      }

      const response = await fetch('https://evercorenutrition.com/ev_admin/api/wishlist/', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: String(customerId),
          product_id: productId,
          quantity: quantity,
        }),
      });

      if (response.ok) {
        setWishlist(prev => [...prev, productId]);
        showToast('Item added to wishlist!', true);
        window.dispatchEvent(new Event('wishlistUpdated'));
        return true;
      } else if (response.status === 401) {
        localStorage.removeItem('authToken');
        showToast('Session expired. Please login again.', false);
        setShowLoginPopup(true);
      } else {
        const errorData = await response.json().catch(() => ({}));
        showToast(errorData.message || errorData.error || 'Failed to add to wishlist.', false);
      }
      return false;
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      showToast('Network error. Please try again.', false);
      return false;
    } finally {
      setWishlistLoading(prev => ({ ...prev, [productId]: false }));
    }
  };

  // Remove from wishlist
  const removeFromWishlistAPI = async (productId) => {
    if (!isAuthenticated()) {
      setShowLoginPopup(true);
      return false;
    }

    setWishlistLoading(prev => ({ ...prev, [productId]: true }));

    try {
      const token = localStorage.getItem('authToken');
      const customerId = getCustomerId();

      if (!customerId) {
        showToast('Could not identify customer. Please login again.', false);
        return false;
      }

      const response = await fetch(
        `https://evercorenutrition.com/ev_admin/api/wishlist/?customer_id=${customerId}&product_id=${productId}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.ok) {
        setWishlist(prev => prev.filter(id => id !== productId));
        showToast('Item removed from wishlist', true);
        window.dispatchEvent(new Event('wishlistUpdated'));
        return true;
      } else if (response.status === 401) {
        localStorage.removeItem('authToken');
        showToast('Session expired. Please login again.', false);
        setShowLoginPopup(true);
      } else {
        const errorData = await response.json().catch(() => ({}));
        showToast(errorData.message || errorData.error || 'Failed to remove from wishlist.', false);
      }
      return false;
    } catch (error) {
      console.error('Error removing from wishlist:', error);
      showToast('Network error. Please try again.', false);
      return false;
    } finally {
      setWishlistLoading(prev => ({ ...prev, [productId]: false }));
    }
  };

  const toggleWishlist = async (productId) => {
    if (!isAuthenticated()) {
      showToast('Please login to manage wishlist', false);
      setTimeout(() => {
        setShowLoginPopup(true);
      }, 1000);
      return;
    }
    
    if (wishlist.includes(productId)) {
      await removeFromWishlistAPI(productId);
    } else {
      await addToWishlistAPI(productId, 1);
    }
  };

  // Helper function to check if product is in stock based on qty
  const isInStock = (product) => {
    if (product.qty !== undefined && product.qty !== null) {
      return product.qty > 0;
    }
    return product.stock !== "Stockout" && product.stock !== "Out of Stock" && product.stock !== "out_of_stock";
  };

  // FIXED Add to cart with price protection - NEVER change price on subsequent adds
  const addToCart = async (product) => {


     const eventId = uuidv4();
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      value: 1000,
      currency: 'INR'
    }, {
      eventID: eventId
    });
  }

  // Optional: Server Event
  try {
    await fetch('https://evercorenutrition.com/ev_admin/api/fb-event/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event_id: eventId,
        value: 1000
      })
    });
  } catch (error) {
    console.log('FB event error:', error);
  }
    // Prevent double click
    if (addingToCart[product.id]) return;
    
    // Prevent adding the same product within 1 second
    if (lastAddedProduct === product.id) {
      showToast('Please wait before adding again', false);
      return;
    }
    
    if (!isInStock(product)) {
      showToast('This product is currently out of stock', false);
      return;
    }

    setLastAddedProduct(product.id);
    if (addToCartTimeout.current) {
      clearTimeout(addToCartTimeout.current);
    }
    addToCartTimeout.current = setTimeout(() => {
      setLastAddedProduct(null);
    }, 1000);

    setAddingToCart(prev => ({ ...prev, [product.id]: true }));

    const variantId = getVariantIdForCart(product.id);
    const selectedVariant = getSelectedVariant(product.id);

    // CRITICAL: Get the EXACT price from the variant
    let exactPrice = 0;
    if (selectedVariant && selectedVariant.price) {
      exactPrice = parseFloat(selectedVariant.price);
    } else if (product.selling_price) {
      exactPrice = parseFloat(product.selling_price);
    } else if (product.price) {
      exactPrice = parseFloat(product.price);
    }
    
    // Validate price
    const validPrice = (typeof exactPrice === 'number' && !isNaN(exactPrice) && exactPrice > 0) 
      ? exactPrice 
      : 0;
    
    try {
      // If not authenticated, save to guest cart
      if (!isAuthenticated()) {
        const guestCart = getGuestCart();
        const existingItemIndex = guestCart.findIndex(
          item => item.product_id === product.id && item.variant_id === variantId
        );
        
        if (existingItemIndex !== -1) {
          // CRITICAL FIX: ONLY change quantity, NEVER change price
          // Preserve the existing unit_price from the cart item
          const existingPrice = guestCart[existingItemIndex].unit_price;
          guestCart[existingItemIndex].quantity += 1;
          // Keep the original price, don't update it
          guestCart[existingItemIndex].unit_price = existingPrice;
          guestCart[existingItemIndex].price = existingPrice;
        } else {
          // Add new item with correct price
          guestCart.push({
            product_id: product.id,
            variant_id: variantId,
            quantity: 1,
            name: product.name,
            unit_price: validPrice,
            price: validPrice,
            selling_price: validPrice,
            image: product.main_image,
            added_at: new Date().toISOString(),
            item_type: 'product'
          });
        }
        
        saveGuestCart(guestCart);
        showToast('Item added to cart!', true);
        window.dispatchEvent(new Event('cartUpdated'));
        return;
      }

      // User is authenticated - FIRST check if item already exists in cart
      const token = localStorage.getItem('authToken');
      const customerId = getCustomerId();

      if (!customerId) {
        showToast('Could not identify customer. Please login again.', false);
        return;
      }

      // Fetch current cart to check if item exists and get its price
      const currentCartResponse = await fetch(
        `https://evercorenutrition.com/ev_admin/api/cart/?customer_id=${customerId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      let existingItem = null;
      if (currentCartResponse.ok) {
        const cartData = await currentCartResponse.json();
        if (cartData.cart && cartData.cart.items) {
          existingItem = cartData.cart.items.find(
            item => item.product_id === product.id && item.variant_id === variantId
          );
        }
      }

      // If item exists, use its existing price; otherwise use current price
      let priceToSend = validPrice;
      if (existingItem && existingItem.unit_price) {
        priceToSend = parseFloat(existingItem.unit_price);
       
      }

      const response = await fetch('https://evercorenutrition.com/ev_admin/api/cart/', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: customerId,
          product_id: product.id,
          variant_id: variantId,
          quantity: 1,
          // CRITICAL: Send the preserved price if item exists
          unit_price: priceToSend
        }),
      });

      if (response.ok) {
        showToast('Item added to cart!', true);
        window.dispatchEvent(new Event('cartUpdated'));
        setTimeout(() => {
          window.dispatchEvent(new Event('cartUpdated'));
        }, 200);
      } else {
        const errorData = await response.json().catch(() => ({}));
        showToast(errorData.message || errorData.error || 'Failed to add to cart.', false);
      }
    } catch (err) {
      console.error('Add to cart error:', err);
      showToast('Network error. Please try again.', false);
    } finally {
      setTimeout(() => {
        setAddingToCart(prev => ({ ...prev, [product.id]: false }));
      }, 500);
    }
  };

  const shareProduct = (product) => {
    const url = window.location.origin + '/product/' + product.id;
    if (navigator.share) {
      navigator.share({ title: product.name, text: 'Check out this product!', url });
    } else {
      navigator.clipboard.writeText(url);
      showToast('Product link copied!', true);
    }
  };

  const handleFlavorChange = (flavor, checked) => {
    if (checked) setSelectedFlavors([...selectedFlavors, flavor]);
    else setSelectedFlavors(selectedFlavors.filter(f => f !== flavor));
  };

  const handleDiscountChange = (discount, checked) => {
    if (checked) setSelectedDiscounts([...selectedDiscounts, discount]);
    else setSelectedDiscounts(selectedDiscounts.filter(d => d !== discount));
  };

  const handlePackSizeChange = (size, checked) => {
    if (checked) setSelectedPackSizes([...selectedPackSizes, size]);
    else setSelectedPackSizes(selectedPackSizes.filter(s => s !== size));
  };

  const handleClearFilters = () => {
    setSelectedFlavors([]);
    setSelectedDiscounts([]);
    setSelectedPackSizes([]);
    setLocalPriceRange({ min: 0, max: 10000 });
    dispatch(clearAllFilters());
  };

  const closeWarning = () => {
    setShowWarning(false);
    setWarningMessage('');
    setWarningProduct(null);
  };

  // Function to render star rating
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    let stars = '';
    
    for (let i = 0; i < fullStars; i++) {
      stars += '★';
    }
    
    if (hasHalfStar) {
      stars += '½';
    }
    
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars += '☆';
    }
    
    return stars;
  };

  // ===========================================
  // ✅ SINGLE EFFECT FOR INITIAL DATA LOADING
  // ===========================================
  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchProducts());
    }
    
    if (isAuthenticated()) {
      fetchWishlistFromAPI();
    }
  }, [status, dispatch]);

  // ===========================================
  // ✅ SINGLE EFFECT FOR ALL FILTERS
  // ===========================================
  useEffect(() => {
    dispatch(setFlavorFilter(selectedFlavors));
    dispatch(setDiscountFilter(selectedDiscounts));
    dispatch(setPackSizeFilter(selectedPackSizes));
    dispatch(setPriceRange(priceRange));
  }, [selectedFlavors, selectedDiscounts, selectedPackSizes, priceRange, dispatch]);

  // ===========================================
  // ✅ SINGLE EFFECT FOR VARIANT SELECTION
  // ===========================================
  useEffect(() => {
    if (allProducts && allProducts.length > 0) {
      setSelectedVariants(prev => {
        const updated = { ...prev };

        allProducts.forEach(product => {
          const defaultVariant = getDefaultVariant(product);

          if (!updated[product.id] && defaultVariant) {
            updated[product.id] = defaultVariant.id;
          } else if (updated[product.id]) {
            const stillExists = product.variants?.some(
              v => String(v.id) === String(updated[product.id])
            );

            if (!stillExists && defaultVariant) {
              updated[product.id] = defaultVariant.id;
            }
          }
        });

        return updated;
      });
    }
  }, [allProducts]);

  // ===========================================
  // ✅ SINGLE EFFECT FOR FILTER OPTIONS
  // ===========================================
  useEffect(() => {
    if (allProducts && allProducts.length > 0) {
      const flavours = new Set();
      const packSizes = new Set();
      
      allProducts.forEach(product => {
        if (product.variants && product.variants.length > 0) {
          product.variants.forEach(variant => {
            if (variant.flavour && variant.flavour !== 'Default') {
              flavours.add(variant.flavour);
            }
            if (variant.weight_display) {
              packSizes.add(variant.weight_display);
            }
          });
        }
      });
      
      setAvailableFlavours([...flavours].sort());
      setAvailablePackSizes([...packSizes].sort());
    }
  }, [allProducts]);

  // ===========================================
  // ✅ SINGLE EFFECT FOR UI INITIALIZATION
  // ===========================================
  useEffect(() => {
    $('.addcart-button').click(function () {
      $(this).next().addClass('open');
      $('.add-to-cart-box .qty-input').val('1');
    });
    $('.qty-left-minus').on('click', function () {
      var $qty = $(this).siblings('.qty-input');
      var _val = $($qty).val();
      if (_val === '1') {
        var _removeCls = $(this).parents('.cart_qty');
        $(_removeCls).removeClass('open');
      }
      var currentVal = parseInt($qty.val());
      if (!isNaN(currentVal) && currentVal > 0) {
        $qty.val(currentVal - 1);
      }
    });
    $('.qty-right-plus').click(function () {
      if ($(this).prev().val() < 9) {
        $(this).prev().val(+$(this).prev().val() + 1);
      }
    });
    
    return () => {
      $('.addcart-button').off('click');
      $('.qty-left-minus').off('click');
      $('.qty-right-plus').off('click');
    };
  }, []);
  
  // ===========================================
  // ✅ CLEANUP TIMEOUT ON UNMOUNT
  // ===========================================
  useEffect(() => {
    return () => {
      if (addToCartTimeout.current) {
        clearTimeout(addToCartTimeout.current);
      }
    };
  }, []);

  if (status === 'loading') {
    return (
      <>
        <Navbar />
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (status === 'failed') {
    return (
      <>
        <Navbar />
        <div className="text-center py-5">
          <div className="alert alert-danger" role="alert">
            Error loading products: {error}
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      {/* Toast Notification */}
      {showWarning && (
        <div style={{
          position: 'fixed', top: '20px', right: '20px',
          backgroundColor: warningMessage.includes('added') || warningMessage.includes('removed') || warningMessage.includes('copied') || warningMessage.includes('Saved') ? '#4CAF50' : 
                         (warningMessage.includes('out of stock') ? '#ff9800' : '#ff4444'),
          color: 'white', padding: '15px 25px', borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 9999,
          display: 'flex', alignItems: 'center', gap: '10px', animation: 'slideIn 0.3s ease'
        }}>
          <i className={`fa-${warningMessage.includes('added') || warningMessage.includes('removed') || warningMessage.includes('copied') || warningMessage.includes('Saved') ? 'regular fa-circle-check' : 'solid fa-circle-exclamation'}`}></i>
          <span>{warningMessage}</span>
          <button onClick={closeWarning} style={{ background: 'none', border: 'none', color: 'white', marginLeft: '10px', cursor: 'pointer', fontSize: '18px' }}>×</button>
        </div>
      )}

      {/* Login Popup Modal */}
      {showLoginPopup && (
        <div className="login-popup-overlay" onClick={() => setShowLoginPopup(false)}>
          <div className="login-popup-container" onClick={(e) => e.stopPropagation()}>
            <button className="login-popup-close" onClick={() => setShowLoginPopup(false)}>
              <i className="fa-solid fa-times"></i>
            </button>
            <Login setOpen={setShowLoginPopup} onLoginSuccess={handleLoginSuccess} />
          </div>
        </div>
      )}

      <section className="section-b-space shop-section">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="show-button flex flex-wrap items-center gap-2 p-4 bg-white md:p-2">
                <button
                  className="flex-1 min-w-[140px] px-4 py-2 bg-gray-200 text-sm font-medium text-gray-800 rounded-md hover:bg-gray-300 active:bg-gray-400 transition-all md:flex-none md:px-3 md:text-base sidebar-filter-menu btn"
                  type="button"
                  onClick={() => setFilterOpen(!filterOpen)}
                >
                  <i className="fa-solid fa-filter mr-2"></i>
                  Filter 
                </button>
                {(selectedFlavors.length > 0 || selectedDiscounts.length > 0 ||
                  selectedPackSizes.length > 0 || priceRange.max < 10000) && (
                 <button 
                  onClick={handleClearFilters}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                  Clear Filters
                </button>
                )}
              </div>

              {/* Filter Section */}
              <div className={`top-filter-category ${filterOpen ? 'show' : ''}`}>
                <div className="row g-sm-4 g-3">
                  <div className="col-xl-3 col-md-6">
                    <div className="category-title"><h3 style={{ color: '#000' }}>Flavor</h3></div>
                    <ul className="category-list custom-padding custom-height">
                      {availableFlavours.length > 0 ? (
                        availableFlavours.map((flavor, i) => (
                          <li key={flavor}>
                            <div className="form-check ps-0 m-0 category-list-box">
                              <input 
                                className="checkbox_animated" 
                                type="checkbox" 
                                id={`flavor${i}`}
                                onChange={(e) => handleFlavorChange(flavor, e.target.checked)}
                                checked={selectedFlavors.includes(flavor)} 
                              />
                              <label className="form-check-label" htmlFor={`flavor${i}`}>
                                <span className="name">{flavor}</span>
                              </label>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="text-muted">No flavours available</li>
                      )}
                    </ul>
                  </div>

                  <div className="col-xl-3 col-md-6">
                    <div className="category-title"><h3 style={{ color: '#000' }}>Price Range</h3></div>
                    <div className="range-slider p-3">
                      <input type="range" className="form-range" min="0" max="10000" step="100"
                        value={priceRange.max}
                        onChange={(e) => setLocalPriceRange({ ...priceRange, max: parseInt(e.target.value) })} />
                      <div className="d-flex justify-content-between mt-2">
                        <span>₹0</span><span>₹{priceRange.max}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-md-6">
                    <div className="category-title"><h3 style={{ color: '#000' }}>Discount</h3></div>
                    <ul className="category-list">
                      {[['upto5', 'Upto 5%'], ['5to10', '5% - 10%'], ['10to15', '10% - 15%'], ['15to25', '15% - 25%'], ['above25', 'Above 25%']].map(([val, label], i) => (
                        <li key={val}>
                          <div className="form-check ps-0 m-0 category-list-box">
                            <input className="checkbox_animated" type="checkbox" id={`discount${i + 1}`}
                              onChange={(e) => handleDiscountChange(val, e.target.checked)}
                              checked={selectedDiscounts.includes(val)} />
                            <label className="form-check-label" htmlFor={`discount${i + 1}`}>
                              <span className="name">{label}</span>
                            </label>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="col-xl-3 col-md-6">
                    <div className="category-title"><h3 style={{ color: '#000' }}>Pack Size</h3></div>
                    <ul className="category-list custom-padding custom-height">
                      {availablePackSizes.length > 0 ? (
                        availablePackSizes.map((size, i) => (
                          <li key={size}>
                            <div className="form-check ps-0 m-0 category-list-box">
                              <input 
                                className="checkbox_animated" 
                                type="checkbox" 
                                id={`pack${i}`}
                                onChange={(e) => handlePackSizeChange(size, e.target.checked)}
                                checked={selectedPackSizes.includes(size)} 
                              />
                              <label className="form-check-label" htmlFor={`pack${i}`}>
                                <span className="name">{size}</span>
                              </label>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="text-muted">No pack sizes available</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Products Grid */}
              <div className="row" style={{ margin: 0 }}>
                <div className="col-12" style={{ padding: 0 }}>
                  <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr', width: '100%', margin: 0, padding: 0 }}>

                    {filteredProducts.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '40px', gridColumn: '1/-1' }}>
                        <h4>No products found matching your filters</h4>
                      </div>
                    ) : (
                      filteredProducts.map((product) => {
                        const isInWishlist = wishlist.includes(product.id);
                        const isWishlistLoading = wishlistLoading[product.id];
                        const inStock = isInStock(product);
                        const averageRating = product.average_rating || 0;
                        const selectedVariant = getSelectedVariant(product.id);

                        const variantPrice = parseFloat(
                          selectedVariant?.price ?? product.selling_price ?? 0
                        );

                        const variantOriginalPrice = parseFloat(
                          selectedVariant?.mrp ?? product.price ?? 0
                        );

                        const variantDiscount = parseFloat(
                          selectedVariant?.discount ?? product.discount ?? 0
                        );

                        const variantPackSize =
                          selectedVariant?.weight_display ||
                          `${selectedVariant?.weight_value || product.weight_value || ''}${selectedVariant?.weight_unit || product.weight_unit || ''}`;

                        const variantImage =
                          selectedVariant?.main_image ||
                          selectedVariant?.image_url ||
                          getProductImage(product);

                        return (
                          <div key={product.id} style={{ width: '100%', padding: 0, margin: 0, boxShadow: "1px 2px 15px #868585", borderRadius: "10px" }}>
                            <div
                              onClick={() => navigate(`/product/${product.id}`)}
                              style={{
                                borderRadius: '12px', overflow: 'hidden',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                backgroundColor: '#f0f0f0', display: 'flex',
                                flexDirection: 'column', height: '100%',
                                cursor: 'pointer', position: 'relative',
                                opacity: inStock ? 1 : 0.8
                              }}
                              onMouseEnter={(e) => {
                                if (window.innerWidth > 768 && inStock) {
                                  e.currentTarget.style.transform = 'translateY(-5px)';
                                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                              }}
                            >
                              {/* Stock Status Badge */}
                              {!inStock && (
                                <div style={{
                                  position: 'absolute',
                                  top: '10px',
                                  left: '10px',
                                  backgroundColor: '#ff4444',
                                  color: 'white',
                                  padding: '4px 12px',
                                  borderRadius: '20px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  zIndex: 3,
                                  boxShadow: '0 2px 8px rgba(255,68,68,0.3)'
                                }}>
                                  <i className="fa-solid fa-clock" style={{ marginRight: '5px' }}></i>
                                  Out of Stock
                                </div>
                              )}

                              <div style={{ 
                                position: 'relative', 
                                width: '100%',
                                aspectRatio: '1/1',
                                overflow: 'hidden', 
                                backgroundColor: '#f0f0f0' 
                              }}>
                                <img
                                  src={variantImage}
                                  alt={product.name}
                                  style={{ 
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    padding: '0',
                                    transition: 'transform 0.3s ease',
                                    filter: inStock ? 'none' : 'grayscale(50%)'
                                  }}
                                  onMouseEnter={(e) => { if (window.innerWidth > 768 && inStock) e.currentTarget.style.transform = 'scale(1.05)'; }}
                                  onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                />
                                
                                {/* BESTSELLER / MOST POPULAR BADGE - Check variant directly */}
                                {(() => {
                                  // Get the selected variant or default variant
                                  const variantToCheck = selectedVariant || getDefaultVariant(product);
                                  // Check if the variant has is_bestseller or is_most_popular = true
                                  const isBestseller = variantToCheck?.is_bestseller === true;
                                  const isMostPopular = variantToCheck?.is_most_popular === true;
                                  
                                  if (isBestseller || isMostPopular) {
                                    return (
                                      <div style={{
                                        position: 'absolute',
                                        top: '10px',
                                        left: '10px',
                                        backgroundColor: '#ff9800',
                                        color: 'white',
                                        padding: '4px 12px',
                                        borderRadius: '20px',
                                        fontSize: '11px',
                                        fontWeight: '700',
                                        zIndex: 3,
                                        boxShadow: '0 2px 8px rgba(255,152,0,0.3)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        letterSpacing: '0.5px'
                                      }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="gold" stroke="gold" strokeWidth="0">
                                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                                        </svg>
                                        {isMostPopular ? 'MOST POPULAR' : 'BESTSELLER'}
                                      </div>
                                    );
                                  }
                                  return null;
                                })()}
                                
                                {/* Stock Status Badge (only show when out of stock) */}
                                {!inStock && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '10px',
                                    left: '10px',
                                    backgroundColor: '#ff4444',
                                    color: 'white',
                                    padding: '4px 12px',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    zIndex: 3,
                                    boxShadow: '0 2px 8px rgba(255,68,68,0.3)'
                                  }}>
                                    <i className="fa-solid fa-clock" style={{ marginRight: '5px' }}></i>
                                    OUT OF STOCK
                                  </div>
                                )}

                                {/* Wishlist Button */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleWishlist(product.id);
                                  }}
                                  disabled={isWishlistLoading}
                                  style={{
                                    position: 'absolute', top: '10px', right: '50px',
                                    width: '35px', height: '35px', borderRadius: '50%',
                                    border: 'none', backgroundColor: 'white',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    cursor: isWishlistLoading ? 'wait' : 'pointer',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    zIndex: 2, opacity: isWishlistLoading ? 0.7 : 1
                                  }}
                                >
                                  {isWishlistLoading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" style={{ width: '16px', height: '16px' }}></span>
                                  ) : (
                                    <i
                                      className={isInWishlist ? 'fa-solid fa-heart' : 'fa-regular fa-heart'}
                                      style={{ color: isInWishlist ? '#ff4444' : '#333', fontSize: '16px' }}
                                    ></i>
                                  )}
                                </button>

                                {/* Share Button */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    shareProduct(product);
                                  }}
                                  style={{
                                    position: 'absolute', top: '10px', right: '10px',
                                    width: '35px', height: '35px', borderRadius: '50%',
                                    border: 'none', backgroundColor: 'white',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    cursor: 'pointer', display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', zIndex: 2
                                  }}
                                >
                                  <i className="fa fa-share-alt" style={{ color: '#333' }}></i>
                                </button>
                              </div>

                              {/* Content Section */}
                              <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', margin: '0 0 8px 0', color: '#333', lineHeight: '1.4' }}>
                                  <span style={{ color: '#333', textDecoration: 'none' }}>
                                    {product.name}
                                  </span>
                                </h3>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                                  <div style={{ color: '#ffc107', fontSize: '1rem', letterSpacing: '2px', marginRight: '5px' }}>
                                    {renderStars(averageRating)}
                                  </div>
                                  <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '5px' }}>
                                    ({averageRating > 0 ? averageRating.toFixed(1) : '0.0'})
                                  </span>
                                  <span style={{ fontSize: '0.85rem', color: '#999', marginLeft: '5px' }}>
                                    ({product.total_reviews || 0} {product.total_reviews === 1 ? 'review' : 'reviews'})
                                  </span>
                                </div>

                                <p style={{ fontSize: '0.9rem', color: '#666', margin: '0 0 10px 0' }}>
                                  {variantPackSize}
                                </p>

                                <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px' }}>
                                  <span style={{ fontSize: '1.3rem', fontWeight: '700', color: '#333' }}>
                                    ₹{parseFloat(variantPrice || 0).toLocaleString('en-IN')}
                                  </span>
                                   {variantOriginalPrice > variantPrice && (
                                    <span style={{ fontSize: '0.9rem', color: '#999', textDecoration: 'line-through', marginLeft: '8px' }}>
                                      ₹{parseFloat(variantOriginalPrice || 0).toLocaleString('en-IN')}
                                    </span>
                                  )}
                                  {variantDiscount > 0 && (
                                    <>
                                      <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '3px',
                                        fontSize: '0.75rem',
                                        color: '#fff',
                                        backgroundColor: '#e53935',
                                        padding: '4px 10px',
                                        borderRadius: '20px',
                                        marginLeft: '4px',
                                        fontWeight: '700',
                                        whiteSpace: 'nowrap'
                                      }}>
                                        {Math.round(variantDiscount)}% OFF
                                      </span>
                                      {variantOriginalPrice > variantPrice && (
                                        <span style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          gap: '4px',
                                          fontSize: '0.75rem',
                                          color: '#2e7d32',
                                          backgroundColor: '#e8f5e9',
                                          padding: '4px 10px',
                                          borderRadius: '20px',
                                          marginLeft: '4px',
                                          fontWeight: '700',
                                          border: '1px solid #a5d6a7',
                                          whiteSpace: 'nowrap'
                                        }}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                                            <line x1="7" y1="7" x2="7.01" y2="7"/>
                                          </svg>
                                          Save ₹{Math.floor(parseFloat(variantOriginalPrice) - parseFloat(variantPrice)).toLocaleString('en-IN')}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </div>

                                {/* Add to Cart Button */}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    addToCart(product);
                                  }}
                                  disabled={!inStock || addingToCart[product.id] || lastAddedProduct === product.id}
                                  style={{ 
                                    width: '100%',
                                    padding: '10px 12px', 
                                    backgroundColor: !inStock ? '#999' : (addingToCart[product.id] || lastAddedProduct === product.id ? '#666' : '#000'), 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px', 
                                    fontSize: '0.9rem', 
                                    fontWeight: '600', 
                                    cursor: (!inStock || addingToCart[product.id] || lastAddedProduct === product.id) ? 'not-allowed' : 'pointer', 
                                    transition: 'background-color 0.2s ease',
                                    opacity: (!inStock || addingToCart[product.id] || lastAddedProduct === product.id) ? 0.7 : 1,
                                    marginTop: 'auto'
                                  }}
                                  onMouseEnter={(e) => { 
                                    if (window.innerWidth > 768 && inStock && !addingToCart[product.id] && lastAddedProduct !== product.id) {
                                      e.currentTarget.style.backgroundColor = '#333'; 
                                    }
                                  }}
                                  onMouseLeave={(e) => { 
                                    if (inStock && !addingToCart[product.id] && lastAddedProduct !== product.id) {
                                      e.currentTarget.style.backgroundColor = '#000'; 
                                    }
                                  }}
                                >
                                  {addingToCart[product.id] ? (
                                    <span className="spinner-border spinner-border-sm" role="status" style={{ width: '14px', height: '14px', marginRight: '5px' }}></span>
                                  ) : null}
                                  {!inStock ? 'Out of Stock' : (addingToCart[product.id] ? 'Adding...' : (lastAddedProduct === product.id ? 'Added!' : 'Add to Cart'))}
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (min-width: 768px) {
          div[style*="display: grid"][style*="gap: 20px"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (min-width: 1200px) {
          div[style*="display: grid"][style*="gap: 20px"] {
            grid-template-columns: repeat(4, 1fr) !important;
          }
        }
        .container-fluid-lg {
          padding-left: 15px !important;
          padding-right: 15px !important;
        }
        @media (min-width: 768px) {
          .container-fluid-lg { padding-left: 20px !important; padding-right: 20px !important; }
        }
        @media (min-width: 1200px) {
          .container-fluid-lg { padding-left: 30px !important; padding-right: 30px !important; }
        }
        .row { margin-left: 0 !important; margin-right: 0 !important; }
        .col-12 { padding-left: 0 !important; padding-right: 0 !important; }
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        /* Login Popup Styles */
        .login-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: fadeIn 0.3s ease;
        }

        .login-popup-container {
          position: relative;
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          background: transparent;
          border-radius: 20px;
          animation: slideUp 0.3s ease;
        }

        .login-popup-close {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: white;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          font-size: 16px;
          color: #333;
          transition: all 0.2s ease;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .login-popup-close:hover {
          background: #f0f0f0;
          transform: scale(1.1);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>

      <ComboSection title="Combo Offers" />
      <Footer />
    </>
  );
};

export default Shop;